// Das Kontomenü im Header (app/views/shared/_account_menu.html.erb).
//
// Öffnen, Licht-Dismiss und Esc erledigt das native Popover selbst -- der
// Knopf trägt `popovertarget`, hier läuft kein Klick-Handler. Was der Browser
// nicht liefert, sind zwei Kleinigkeiten: ein Popover liegt im Top-Layer mit
// position: fixed und muss unter den Knopf gerechnet werden, und der Knopf
// soll `aria-expanded` tragen, was `popovertarget` allein nicht nachführt.
//
// Die Rechnung ist eine reine Funktion, damit vitest sie ohne DOM prüft
// (environment: node); das Anhängen an die Seite entscheidet nichts.

interface ButtonEdges {
  right: number
  bottom: number
}

// Nie näher als 8px an eine Viewport-Kante -- auf dem Handy endet der Knopf
// fast am rechten Rand, und ein Panel bündig an der Kante sähe abgeschnitten
// aus.
const EDGE = 8
const GAP = 8

/** Where the panel goes: under the button, right edges aligned, clamped to the viewport. */
export function menuPosition(button: ButtonEdges, panelWidth: number, viewportWidth: number): {
  top: number
  left: number
} {
  const left = Math.max(EDGE, Math.min(button.right - panelWidth, viewportWidth - panelWidth - EDGE))
  return { top: button.bottom + GAP, left }
}

export function startAccountMenu(doc: Document = document): void {
  const button = doc.querySelector<HTMLButtonElement>('.site-nav__menu-button')
  const panel = doc.getElementById('account-menu')
  if (!button || !panel) return

  const place = (): void => {
    const rect = button.getBoundingClientRect()
    const { top, left } = menuPosition(rect, panel.offsetWidth, doc.documentElement.clientWidth)
    panel.style.top = `${top}px`
    panel.style.left = `${left}px`
  }

  panel.addEventListener('toggle', (event) => {
    const open = (event as ToggleEvent).newState === 'open'
    button.setAttribute('aria-expanded', String(open))
    if (open) place()
  })

  // Dreht jemand das Gerät, während das Menü offen ist, stünde das Panel
  // sonst an der alten Stelle -- oder außerhalb des Fensters.
  window.addEventListener('resize', () => {
    if (panel.matches(':popover-open')) place()
  })
}
